---
de:
  general:
    24h_stats: 24h stats
    5min_stats: 5min stats
    7d_stats: 7tage stats
    access_level:
      admin: Admin
      developer: Entwickler
      editor: Editor
      landowner: Grundbesitzer
      portfolio: Portfolio
    access_rights: Zugangsrechte
    action_might_be_irreversible: Diese Aktion könnte nicht rückgängig gemacht werden.
    activate: Aktivieren
    active: Aktiv
    activity: Aktivität
    actual: Aktuell
    add: Hinzufügen
    add_as_custom_chart: Als benutzerdefiniertes Diagramm hinzufügen?
    add_attachment: Anhang hinzufügen
    add_image: Bild hinzufügen
    add_new: Neu hinzufügen
    add_power-plant-supplier_connection: Kraftwerkslieferantenverbindung hinzufügen
    add_supplier_role: Lieferantenrolle hinzufügen
    add_user: Benutzer hinzufügen
    admin: Admin
    all: Alle
    all_caps: ALL
    and: und
    apply: Anwenden
    are_you_sure: Bist du sicher?
    area: Bereich
    area_price: Gebietpreis
    asset_class: Anlagentyp
    avail_analysis: Verfügbarkeitsanalyse
    availability_calculation: Verfügbarkeitsberechnung
    average_last_24_hours: 24H-Durchschnitt
    avg_price: Durchschnittspreis
    back: Zurück
    back_to_list: Zurück zur Liste
    basic: Basic
    basic_details: Grundlegende Details
    bilateral: Bilateral
    budget: Budget
    budget_lowercase: Budget
    budgets: Budgets
    bulk_edit_hint: Fügen Sie Zahlen direkt aus Excel ein; verwenden Sie tabulatorgetrennte Werte zuerst für das Volumen und dann für den Erlös.
    bulk_update: Massenaktualisierung
    cancel: Abbrechen
    cant_delete_company: Unternehmen kann nicht gelöscht werden
    capacity: Kapazität
    card_description: Kartenbeschreibung
    category: Kategorie
    chart_title: Diagrammtitel
    click_to_load_more: Klicken Sie hier, um mehr zu laden
    climate_futures_inflow: Climate Futures Zufluss
    close: Schließen
    commercial_details: Kommerzielle Details
    community: Community
    companies: Unternehmen
    company: Unternehmen
    company_access: Firmenzugang
    confirm: Bestätigen
    confirmed: Bestätigt
    connections: Verbindungen
    contact_kaiasolutions: Wechseln Sie zu einem individuellen Portfolio mit entsprechenden Zugriff oder kontaktieren Sie das Portalpersonal, wenn Sie diese Funktion aktivieren möchten.
    contract_deleted: Vertrag gelöscht
    contract_details: Vertragsdetails
    contract_type: Vertragstyp
    contracts_admin: Verträge Admin
    copied: Kopiert!
    copy: Kopieren
    country: Land
    county: Kreis
    create: Erstellen
    created: Erstellt
    custom_lower_limit: Benutzerdef
    custom_unit: Benutzerdefinierte Einheit
    custom_upper_limit: Benutzerdef
    daily: Täglich
    data_source: Datenquelle
    data_source_configuration: Datenquellenkonfiguration
    date: Datum
    date_from: Stammen aus
    date_scope: Datum
    date_to: Datum bis
    days: Tage
    de: Deutsch
    deactivate: Deaktivieren
    delete: Löschen
    delete_all: Alles löschen
    delete_failed: Löschen fehlgeschlagen
    deleted: Gelöscht
    description: Beschreibung
    details: Details
    deviation: Abweichung
    download: Herunterladen
    edit: Bearbeiten
    edit_supplier_role: Lieferantenrolle bearbeiten
    edit_user: Benutzer bearbeiten
    elcert: Elcert
    elcert/GoO: Elcert / GoO
    elcert_full: Elzertifikate
    email: E-Mail
    en: Englisch
    end_date: Enddatum
    energy: Energie
    error: Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.
    error_reset_password: Fehler beim Zurücksetzen des Passworts
    est_resource: Geschätzte Ressourcen
    event: Ereignis
    export_access: Exportzugriff
    feature_configuration: Funktionskonfiguration
    filter: Filtern
    filter_by_company: Filtern nach Unternehmen
    filter_data: Daten filtern
    first_name: Vorname
    flip_sign: Vorzeichen umkehren
    forecast: Vorhersage
    forecast_lowercase: Vorhersage
    fr: Französisch
    general: Allgemein
    go_expiry_date: Ablaufdatum des GO
    go_full: Garantiezertifikat
    gwh: GWh
    half_yearly: Halbjährlich
    hide: Ausblenden
    hourly: Stündlich
    hours: Stunden
    hydro: Hydro
    image: Bild
    inactive: Inaktiv
    inflow: Zufluss
    intake: Einlass
    ip: IP
    language: Sprache
    last_activity: Letzte Aktivität
    last_name: Nachname
    limit: Grenze
    links: Links
    lock_account: Konto sperren
    logged_in_successfully: Erfolgreich angemeldet
    login: Anmelden
    login_failed: Anmeldung fehlgeschlagen
    login_failures: Anmeldefehler
    logo: Logo
    metering_point: Messpunkt
    month: Monat
    monthly: Monatlich
    mw: MW
    name: Name
    nb: Norwegisch
    new: neu
    'no': Nein
    no_image_available: Kein Bild verfügbar
    none: Keine
    not_enabled: ist für das ausgewählte Portfolio oder alle Portfolios in der globalen Auswahl nicht aktiviert.
    not_specified: Nicht angegeben
    now: jetzt
    number_of_power_plants: Anzahl Kraftwerke
    nve_metadata: NVE-Metadaten
    ny_budget: NY Budget
    offset: Offset
    operational_state: Betriebsstatus
    or: oder
    org_no: Org. no
    other_info: Andere Informationen
    overview: Übersicht
    pareto: Pareto
    password: Passwort
    path: Pfad
    power_plant: Kraftwerk
    power_plant_lowercase: Kraftwerk
    power_plant_names: Kraftwerksnamen
    power_plants: Kraftwerke
    power_plants_lowercase: Kraftwerke
    power_prices: Strompreise
    power_production: Stromproduktion
    power_sales: Stromverkäufe
    precipitation: Niederschlag
    price: Preis
    price_area: Preiszone
    production: Produktion
    production_budget: Produktionsbudget
    production_forecast: Vorhergesagte Produktion
    profile: Profil
    profile_lowercase: Profil
    project: Projekt
    quarterly: Quartalsweise
    radiation: Strahlung
    remove: Entfernen
    remove_attachment: Anhang entfernen
    remove_image: Bild entfernen
    report_generated: Bericht erstellt
    requests: Anfragen
    reset: Zurücksetzen
    reset_password: Passwort zurücksetzen
    resolution: Auflösung
    result: Ergebnis
    result_lowercase: Ergebnis
    retry: Erneut versuchen
    revenue: Umsätze
    revenue_budget: Budgetierte Umsätze
    rotate: Rotieren
    runoff: Abfluss
    save: Speichern
    save_successful: Speichern erfolgreich
    saved: Gespeichert
    scale_factor: Skalierungsfaktor
    search: Suche
    search_by: Suche nach Name, E-Mail oder Zugriffsebene
    search_by_name: Suche nach Name
    search_companies: Suche unternehmen
    search_counties: Suche landkreise
    search_powerplants: Suche kraftwerke
    seconds: Sekunden
    select: Auswählen
    select_asset_type: Anlagentyp auswählen
    select_columns: Spalten auswählen
    selection: Auswahl
    send: Senden
    sensors: Nest-Sensoren
    show: Zeigen
    show_edit: Anzeigen/Bearbeiten
    show_less: Weniger anzeigen
    show_more: "%{count} weitere anzeigen"
    show_subsidiaries: Tochtergesellschaften anzeigen
    slowest: Langsamste
    snow: Schnee
    solar: Solar
    solar_backend_configuration: Solar-Backend-Konfiguration
    sort_by: Sortieren nach
    spot_price: Spotpreis
    start_date: Startdatum
    statistics: Statistiken
    status: Status
    summary: Zusammenfassung
    supplier_contact_email: Lieferantenkontakt-E-Mail
    supplier_contact_phone: Lieferantenkontakttelefon
    supplier_name: Lieferantenname
    temperature: Temperatur
    tertiary: Tertiär
    timestamp: Zeitstempel
    title: Titel
    to: bis
    today: Heute
    token: Token
    top: Top
    total: Gesamt
    total_production: Gesamtproduktion
    trend_last_24_hours: 24H-Trend
    treshold_mw: Schwellenwert MW
    unexpected_error: Unerwarteter Fehler
    unknown: Unbekannt
    unknown_error: Etwas ist schiefgelaufen
    unlock_account: Konto entsperren
    unsaved_changes: Sie haben nicht gespeicherte Änderungen.
    update: Aktualisieren
    updated: Aktualisiert
    user_access_level: Zugriffsebene
    valid_contract: Gültiger Vertrag
    validations:
      non_negative: Nicht negativ
      required: Erforderlich
    view_details: Details anzeigen
    volume: Volumen
    volume_percent: Volumenprozent
    weekly: Wöchentlich
    welcome: Willkommen
    wind: Wind
    wind_backend_configuration: Wind-Backend-Konfiguration
    wind_speed: Windgeschwindigkeit
    wrong_email_or_password: Falsche E-Mail-Adresse oder falsches Passwort
    year: Jahr
    yearly: Jährlich
    'yes': Ja
